import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Scrolls the window back to the top whenever the route pathname changes.
 * Prevents new pages (e.g. property detail) from opening mid-scroll.
 */
export const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
};